import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const sanitiseHtml = (content: string) =>
  parse(DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }));

export default sanitiseHtml;
